import type { SalesBlocker, Severity } from '../../types/api'
import { SeverityBadge, TonePill } from '../shared/Badge'

interface SalesBlockersProps {
  blockers: SalesBlocker[]
}

const SEVERITIES: Severity[] = ['critical', 'high', 'medium', 'low']

export function SalesBlockers({ blockers }: SalesBlockersProps) {
  if (blockers.length === 0) {
    return (
      <div className="text-[13px] text-success bg-chip-success border border-success/30 rounded-lg px-4 py-3">
        ✓ No direct sales blockers detected. Security and dependency licensing are acceptable for enterprise sales qualification.
      </div>
    )
  }

  return (
    <div className="space-y-2">
      {blockers.map((b) => (
        <div key={b.finding_id} className="border border-hairline rounded-lg shadow-card px-4 py-3 bg-panel flex items-start gap-3">
          {/* The one pill style (DEC-193), in a fixed slot (decision 3). */}
          <span className="w-[92px] flex-none mt-0.5">
            {SEVERITIES.includes(b.severity as Severity) ? (
              <SeverityBadge severity={b.severity as Severity} />
            ) : (
              <TonePill tone="neutral">{b.severity}</TonePill>
            )}
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-[13px] font-medium text-ink">{b.deal_risk_label}</p>
            <p className="text-[11px] text-muted mt-0.5 truncate">{b.human_summary}</p>
          </div>
          <p className="text-[12px] tabular-nums text-faint shrink-0">{b.estimated_effort_hours.toFixed(0)}h</p>
        </div>
      ))}
    </div>
  )
}
